import Logo from '../header/Logo';
import Box from '@mui/material/Box';
//import User from './User';
import Navigation from '../header/Navigation';

export default function Header() {
  return (
    <Box component="header" sx={rootSx}>
        <Logo />
        <Navigation />
        {/*<User />*/}
    </Box>
  );
}

const rootSx = {
  top: '0',
  zIndex: 1200,
  width: '100%',
  position: 'fixed',
  height: { xs: '4rem', sm: '4.5rem' },
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  justifyContent: 'space-between',
  backgroundColor: 'rgba(5, 5, 5, 0.72)',
  borderBottom: '1px solid rgba(255, 255, 255, .12)',
  backdropFilter: 'blur(18px)'
}
